export default __webpack_public_path__ + "static/D-DINCondensed-8dc13fbf0e022838a6dcc4f92b5b5060.woff";